import { Component, computed, inject } from '@angular/core';
import { AuthSessionService } from '../../auth-session.service';

@Component({
  imports: [],
  selector: 'app-destination',
  styleUrl: './destination.scss',
  templateUrl: './destination.html',
})
export class Destination {
  readonly version = inject(AuthSessionService).paxVersion;
  // VIP/Host rate differs from GSCS & EDA qualifiers.
  readonly extensionRate = computed(() => (this.version() === 'VIP' ? 679 : 359));
}
